import { useForm } from 'react-hook-form'
import { useGlobalToast } from 'transfix-ui/components/Toast/GlobalToast'
import { IUpdateShipmentIssueInput } from 'types/graphqlTypes'
import { IIssueFragment } from 'apps/marketplace/pages/issues/graphql/IssueFragment'
import formatCamelToTitleCase from 'utils/camelToTitleCase'
import { IShipmentIssueDetailsFragment } from '../graphql/ShipmentIssueDetailsFragment'
import { useUpdateShipmentIssueMutation } from '../graphql/UpdateShipmentIssue'

export const useEditIssue = (issue: IShipmentIssueDetailsFragment | IIssueFragment) => {
  const { openToast } = useGlobalToast()
  const formProps = useForm()
  const [updateShipmentIssue] = useUpdateShipmentIssueMutation()

  const editIssue = async (payload: Partial<IUpdateShipmentIssueInput>) => {
    const updatedFields = Object.keys(payload)
      .map(formatCamelToTitleCase)
      .join(' & ')
      .replaceAll('Id', '')

    try {
      await updateShipmentIssue({
        variables: {
          input: {
            id: issue?.id || '',
            ...payload,
          },
        },
      })

      openToast({
        toastMessage: `Updated ${updatedFields}`,
        toastType: 'default',
      })
    } catch (e) {
      openToast({
        toastMessage: `Error updating ${updatedFields}`,
        toastType: 'alert',
      })
    }
  }

  return {
    editIssue,
    formProps,
  }
}

export default useEditIssue
